import { render, staticRenderFns } from "./turnover.vue?vue&type=template&id=610ff68b&scoped=true&"
import script from "./turnover.vue?vue&type=script&lang=js&"
export * from "./turnover.vue?vue&type=script&lang=js&"
import style0 from "./turnover.vue?vue&type=style&index=0&id=610ff68b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ff68b",
  null
  
)

export default component.exports